/**
 * Longer than the pause between keystrokes of someone typing at a normal pace (about half a
 * second), so typing an address issues one search rather than one per character. Each search fans
 * out into several queries against the agency's GIS server, which can be slow to answer them.
 */
export const LOCATION_SEARCH_DEBOUNCE_MS = 700;

/** Shorter queries match too much of the agency's parcel layer to be worth searching. */
export const LOCATION_SEARCH_MIN_CHARS = 3;

export const isSearchableLocationQuery = (query: string | null | undefined): boolean =>
  (query ?? '').trim().length >= LOCATION_SEARCH_MIN_CHARS;
